import validate from "/app/node_modules/.pnpm/nuxt@3.16.2_@azure+identity@4.8.0_@parcel+watcher@2.5.1_@types+node@22.0.0_db0@0.3.1_ioredis@_xh6s36qx4ibz4tjsyubyprs3y4/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.16.2_@azure+identity@4.8.0_@parcel+watcher@2.5.1_@types+node@22.0.0_db0@0.3.1_ioredis@_xh6s36qx4ibz4tjsyubyprs3y4/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  anonymous: () => import("/app/middleware/anonymous.ts"),
  auth: () => import("/app/middleware/auth.ts"),
  permission: () => import("/app/middleware/permission.ts")
}